module.exports = __webpack_public_path__ + "img/volume-mute.1d0fa007.svg";